import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Mail, UserSearch } from "lucide-react";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";
import { LOGO, US_STATES } from "@/lib/brand";

const selCls = "mt-1.5 w-full h-12 rounded-md bg-[#1E2A5A] border border-white/10 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#E6B34A]";

export default function ForgotAccount() {
  const [birthDate, setBirthDate] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setResults(null);
    try {
      const { data } = await api.post("/auth/forgot-account", { birth_date: birthDate, city, state });
      setResults(data.matches || []);
    } catch (err) { setResults([]); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A1030] p-6">
      <div className="w-full max-w-sm" data-testid="forgot-account-form">
        <div className="flex flex-col items-center text-center mb-8">
          <img src={LOGO} alt="In His Image Radio" className="w-20 h-20 rounded-3xl object-cover mb-4" />
          <h1 className="font-display font-black text-3xl tracking-tighter flex items-center gap-2"><UserSearch className="w-6 h-6 text-[#E6B34A]" /> Find your account</h1>
          <p className="text-zinc-400 mt-2">Enter your birth date and city to find the email on file.</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div><label className="overline text-zinc-400">Birth date</label><Input type="date" value={birthDate} onChange={(e) => setBirthDate(e.target.value)} required data-testid="fa-birthdate" className="mt-1.5 bg-[#1E2A5A] border-white/10 focus-visible:ring-[#E6B34A] h-12" /></div>
          <div><label className="overline text-zinc-400">City</label><Input value={city} onChange={(e) => setCity(e.target.value)} required data-testid="fa-city" className="mt-1.5 bg-[#1E2A5A] border-white/10 focus-visible:ring-[#E6B34A] h-12" /></div>
          <div>
            <label className="overline text-zinc-400">State (optional)</label>
            <select value={state} onChange={(e) => setState(e.target.value)} data-testid="fa-state" className={selCls}>
              <option value="">Any</option>
              {US_STATES.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <button type="submit" disabled={loading} data-testid="fa-submit" className="w-full h-12 rounded-xl bg-[#E6B34A] text-[#0A1030] font-bold hover:bg-[#CF9A34] transition-colors disabled:opacity-60 flex items-center justify-center">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Find my account"}
          </button>
        </form>

        {results !== null && (
          <div className="mt-6" data-testid="fa-results">
            {results.length === 0 ? (
              <p className="text-sm text-zinc-400 text-center">No accounts matched those details.</p>
            ) : (
              <div className="space-y-2">
                {results.map((r, i) => (
                  <div key={i} className="flex items-center gap-3 rounded-xl bg-[#141C42] border border-white/5 px-4 py-3">
                    <Mail className="w-4 h-4 text-[#E6B34A]" />
                    <div><p className="text-sm font-semibold">{r.title ? `${r.title} ` : ""}{r.name}</p><p className="text-xs text-zinc-400">{r.email_hint}</p></div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
        <p className="text-sm text-zinc-400 text-center mt-6"><Link to="/login" className="text-[#E6B34A] font-semibold">Back to sign in</Link></p>
      </div>
    </div>
  );
}
